import React from 'react';
export default ({ size }) => (
  <svg className="mot-icon" height={size} width={size} viewBox="0 0 256 256">
    <path d="M231.287 177.079a10.744 10.744 0 0 1 5.624 9.446c0 1.367-.256 2.675-.72 3.88H23.85l-21.91-31.25A10.689 10.689 0 0 1 0 152.996c0-2.33.743-4.487 2.002-6.245h62.974l7.467 7.467h127.22l26.365-15.221H256zm-62.66-77.13h37v19.734h-37zm-88.805 27.134h37v19.734h-37zm44.401 0h37v19.734h-37zm44.404 0h37v15.146l-7.949 4.588h-29.051zM79.822 99.949h37v19.734h-37zm44.401 0h37v19.734h-37zM21.721 95.196H61.19v7.4h-8.54v36.75H14.32V80.397h16.52v-5.833l21.811-8.968v14.8h8.538v7.4H21.72z" />
  </svg>
);
